module.exports = __webpack_public_path__ + "assets/img/titans.e7b7c438.jpg";